import { Service, ServiceInitializer } from '@estee/elc-service';
import { ELC_RAMP } from '@estee/elc-service-view-names';
import { IRampAppConfig } from '../internal/domain/entities/Config';
import { RampServiceStartedUseCase } from '../use-cases/RampServiceStartedUseCase';

const { name, version } = __serviceInfo__;

export class RampService extends Service {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
        this.registerView(ELC_RAMP, () =>
            import(
                /* webpackChunkName: 'Ramp' */
                '../exported/Ramp'
            )
        );
    }

    public async start(config: IRampAppConfig) {
        await super.start(config);
        const rampServiceStartedUseCase = new RampServiceStartedUseCase();
        await rampServiceStartedUseCase.execute();
    }
}
